<template>
    <div class="action-schedule">
        <div class="title f-bold" v-html="`일정 선택이 완료되었어요`" />
        <div class="body" v-html="body" />
    </div>
</template>

<script>
export default {
    name: 'ActionScheduleConfirm',
    props: ['message'],
    computed: {
        content() {
            return this.$mustParse(this.message.content)
        },
        body() {
            return `${this.content.name} / ${this.$options.filters.asAge(this.content.birthday)} / ${
                this.content.job
            } 님과<br>약속 일정 최종 확인 중이에요`
        },
    },
}
</script>

<style scoped></style>
